import React from 'react';
import { Layout } from 'fronton-react';
import { RootLayout } from 'common/components';
import { ConsultationSection } from 'remotes/consultation-section';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import {
  FeaturesSection,
  GallerySection,
  HeaderSection,
  ProjectDevelopmentSection,
  ProjectServicesTypesSection,
  STEPS_LIST,
  StepsSection,
} from '../components';
import {
  DEFAULT_CONSULTATION_SECTION_TITLE,
  DEFAULT_CONSULTATION_SUB_CHANNEL,
} from '../engineering-systems-constants';
import { EngineeringSystemTypeProps } from '../engineering-systems-types';
import { SEWERAGE_GALLERY_LIST } from './components/gallery-section';
import { SEWERAGE_HEADER_SECTION_CONFIG } from './components/header-section';
import { SEWERAGE_DEVELOPMENT, SEWERAGE_PROJECT_TYPE_LIST } from './components/project-types-section';
import {
  SEWERAGE_ELEMENT_BLOCK,
  SEWERAGE_SUPPLY_SYSTEMS_CONSULTATION_TYPE,
  SEWERAGE_SYSTEMS_PATH,
} from './sewerage-systems-constants';

/**
 * Вью страницы "Системы водоснабжения и канализации"
 */
export const SewerageSystems = ({
  consultationSectionRef,
  onConsultationSignupBtnClick,
  serviceTypePrice,
}: EngineeringSystemTypeProps) => (
  <RootLayout currentPage={SEWERAGE_SYSTEMS_PATH}>
    <Layout>
      <HeaderSection
        headerConfig={SEWERAGE_HEADER_SECTION_CONFIG}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <FeaturesSection />
      <PromoBlock elementBlock={SEWERAGE_ELEMENT_BLOCK} />
      <SpecialOffer onModalBtnClick={onConsultationSignupBtnClick} elementBlock={SEWERAGE_ELEMENT_BLOCK} />
      {serviceTypePrice && Object.keys(serviceTypePrice).length > 1 ? (
        <ProjectServicesTypesSection
          elementBlock={SEWERAGE_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectTypeList={SEWERAGE_PROJECT_TYPE_LIST}
          serviceTypePrice={serviceTypePrice}
        />
      ) : (
        <ProjectDevelopmentSection
          elementBlock={SEWERAGE_ELEMENT_BLOCK}
          onConsultationSignupBtnClick={onConsultationSignupBtnClick}
          projectDevelopmentInfo={SEWERAGE_DEVELOPMENT}
          serviceTypePrice={serviceTypePrice}
        />
      )}
      <StepsSection stepSectionList={STEPS_LIST} />
      <GallerySection
        elementBlock={SEWERAGE_ELEMENT_BLOCK}
        galleryList={SEWERAGE_GALLERY_LIST}
        onConsultationSignupBtnClick={onConsultationSignupBtnClick}
      />
      <ConsultationSection
        consultationType={SEWERAGE_SUPPLY_SYSTEMS_CONSULTATION_TYPE}
        elementBlock={SEWERAGE_ELEMENT_BLOCK}
        elementText="Заявка на консультацию"
        sectionRef={consultationSectionRef}
        sectionTitle={DEFAULT_CONSULTATION_SECTION_TITLE}
        subChannel={DEFAULT_CONSULTATION_SUB_CHANNEL}
      />
    </Layout>
  </RootLayout>
);
